import { render } from "./AttachmentTypeControl.vue?vue&type=template&id=a8af9cc4&ts=true"
import script from "./AttachmentTypeControl.vue?vue&type=script&lang=ts"
export * from "./AttachmentTypeControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__